import React, { useEffect,useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { TextField, Button, IconButton, Box, Container, Dialog, DialogTitle, DialogContent, DialogActions, LinearProgress, useMediaQuery, Divider } from "@mui/material";
import CancelIcon from '@mui/icons-material/Cancel';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import CloseIcon from "@mui/icons-material/Close";
import { styled, lighten, darken } from '@mui/system';
import Autocomplete from '@mui/material/Autocomplete';
import apiClient from "../api/apiClient";
import DatePicker from "./DatePickers";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
  
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

const FillBankStatement = () => {
  const token = localStorage.getItem("token");
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    username: "",
    privatecode: "",
  });
  const [message, setMessage] = useState("");
  const [openDialog, setOpenDialog] = useState(false); // การแสดง Dialog
  const [dialogMessage, setDialogMessage] = useState(""); // ข้อความที่จะแสดงใน Dialog
  const [dialogTitle, setDialogTitle] = useState("Information"); // ค่าเริ่มต้นเป็น Error
  const [dialogTitleColor, setDialogTitleColor] = useState("black"); 
  const [dialogButtonText, setDialogButtonText] = useState("Close"); // ข้อความปุ่มเริ่มต้นเป็น Close
  const [dialogButtonTextColor, setDialogButtonTextColor] = useState("black"); 
  const [dialogButtonColor, setDialogButtonColor] = useState("white"); 
  const [dialogButtonColorh, setDialogButtonColorh] = useState("white"); 

  const [progress, setProgress] = useState(0); // To track the loading progress
  const [loading, setLoading] = useState(true); // To show loading spinner
  const [files, setFiles] = useState([]);

  const [accountValue, setAccountValue] = useState(null);
  const [dateValue, setDateValue] = useState(null);
  const [radioTypeValue, setRadioTypeValue] = useState('');
  const [arapValue, setArApValue] = useState([]);
  const [currencyValue, setCurrencyValue] = useState([]);
  const [arapSelected, setArApSelected] = useState(null);
  const [currencySelected, setCurrencySelected] = useState(null);
  const [labelText, setLabelText] = useState('');
  const [placeholderText, setPlaceholderText] = useState('');
  const [labelAmount, setLabelAmount] = useState('');
  const [placeholderAmount, setPlaceholderAmount] = useState('');
  const [amountValue, setAmountValue] = useState("");
  const [balanceValue, setBalanceValue] = useState("");

  const transactionRef = useRef();
  const tellerRef = useRef();
  const orgbrRef = useRef();
  const chqnoRef = useRef();
  const remarksRef = useRef();

  dayjs.extend(utc);
  dayjs.extend(timezone);
  
  const fetchBankData = async () => {
      try {      
        setProgress(0); // Reset progress when fetching starts
        const response = await apiClient.get("/api-data/bankaccount-book", {
          headers: {
            'x-screen': 'fillbankstatement',  
            "Authorization": `Bearer ${token}` ,
          },
        });

        if (response.data.bankAccount) {
          const files = response.data.bankAccount;
          const filesTable = files.map(file => ({
            bankname: file.bankname,
            account: file.account,
            type: file.type,
            c8: file.c8,
            c9: file.c9
          }));
  
          // ใช้ setFiles เก็บข้อมูล
          setFiles(filesTable);
        }
  
        setLoading(false); // Data loaded, hide progress bar
        setProgress(100); // Set progress to 100%
  
      } catch (error) {
        // console.error("Failed to fetch file list", error);
        setLoading(false); // Hide loading in case of error
      }
    };
  

  useEffect(() => {
    fetchBankData();
  }, []);

  const options = files.map((option) => {
    const firstLetter = option.bankname.toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
      ...option,
    };
  });

  const GroupHeader = styled('div')(({ theme }) => ({
    position: 'sticky',
    top: '-8px',
    padding: '4px 10px',
    // color: theme.palette.primary.main,
    // backgroundColor: lighten(theme.palette.primary.light, 0.85),
    ...theme.applyStyles('dark', {
      // backgroundColor: darken(theme.palette.primary.main, 0.8),
    }),
  }));

  const GroupItems = styled('ul')({
    padding: 0,
  });
  
  const handleDateChange = (value) => {
    const bangkokTime = value ? dayjs(value).tz('Asia/Bangkok', true) : null;
    setDateValue(bangkokTime);
  };

  const handleRadioChange = async (event) => {
    const value = event.target.value;
    setRadioTypeValue(value);
    setArApSelected(null);
    setCurrencySelected(null);
    try {      
        setProgress(0); // Reset progress when fetching starts
        let response;
        if (value === 'deposit') {
          response = await apiClient.get("/api-data/master-ar", {
            headers: {
              'x-screen': 'fillbankstatement',  
              "Authorization": `Bearer ${token}` ,
            },
          });
          setLabelText("ลูกหนี้/ผู้โอนเงิน");
          setPlaceholderText("Accounts Receivable");
          setLabelAmount("ฝาก");
          setPlaceholderAmount("Deposit");
        } else if (value === 'withdrawal') {
          response = await apiClient.get("/api-data/master-ap", {
            headers: {
              'x-screen': 'fillbankstatement',  
              "Authorization": `Bearer ${token}` ,
            },
          });
          setLabelText("เจ้าหนี้/ผู้รับเงิน");
          setPlaceholderText("Accounts Payable");
          setLabelAmount("ถอน");
          setPlaceholderAmount("Withdrawal");
        } else {
          console.error("Failed to fetch data list", error);
          setLoading(false); 
          setArApValue([]);
          setLabelText('');
          setPlaceholderText('');
          setLabelAmount('');
          setPlaceholderAmount('');
        }

        if (response.data.s=='0' && response.data.d.rowCount > 0) {
          const files = response.data.d.rows;
          const filesTable = files.map(file => ({
            name: file.c1,
            id: file.c2
          }));

          setArApValue(filesTable);
        } else {
          setArApValue([]);
          setLabelText('');
          setPlaceholderText('');
          setLabelAmount('');
          setPlaceholderAmount('');
        }

        response = await apiClient.get("/api-data/master-currency", {
            headers: {
              'x-screen': 'fillbankstatement',  
              "Authorization": `Bearer ${token}` ,
            },
          });

        if (response.data.s=='0' && response.data.d.rowCount > 0) {
          const files = response.data.d.rows;
          const filesTable = files.map(file => ({
            name: file.c1,
            id: file.id
          }));

          setCurrencyValue(filesTable);
        } else {
          setCurrencyValue([]);
        }
  
        setLoading(false); 
        setProgress(100); 
  
    } catch (error) {
      // console.error("Failed to fetch file list", error);
      setLoading(false); // Hide loading in case of error
    }

  };

  const handleSubmit = async (event) => {
    event.preventDefault(); // ป้องกันการ reload หน้าเว็บ

    // Check dateValue
    if (!dateValue) {
      openDialogWithMessage("กรุณาเลือกวันที่/Select Date", "Save Failed", "#e40000", "Close","white","#ff1616","#d40000");
      return;
    }

    // Check radioTypeValue
    if (!radioTypeValue) {
      openDialogWithMessage("กรุณาเลือกประเภทรายการ/Select Type", "Save Failed", "#e40000", "Close","white","#ff1616","#d40000");
      return;
    }

    const dataToSend = {
      account: accountValue?accountValue.account : null,
      date: dateValue ? dateValue.format("YYYY-MM-DD") : null,
      type: radioTypeValue?radioTypeValue : null,
      arap: arapSelected?arapSelected.id : null,
      currency: currencySelected?currencySelected.name : null,
      amount: amountValue?amountValue : null,
      balance: balanceValue?balanceValue : null,
      transaction: transactionRef.current?.value?.trim() || null,
      teller: tellerRef.current?.value?.trim() || null,
      orgbr: orgbrRef.current?.value?.trim() || null,
      chqno: chqnoRef.current?.value?.trim() || null,
      remarks: remarksRef.current?.value?.trim() || null,
      screen: 'fillbankstatement',
      c8: accountValue?accountValue.c8 : null,
      c9: accountValue?accountValue.c9 : null,
    };

    try {
      const response = await apiClient.post("/api-data/banktransaction-create", dataToSend, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.status === 200 && response.data.message != 'Failed to save data') {
        
        openDialogWithMessage(response.data.message, "Save Complete", "#519a39", "OK", "white", "#66bb49", "#3f762c");
        clearForm();
      } else if (response.data.message == 'Failed to save data') {
        openDialogWithMessage(response.data.message || "Failed to save data.", "Save Failed", "#e40000", "Close", "white", "#ff1616", "#d40000");
      }
      
    } catch (error) {
      openDialogWithMessage(error.response?.data?.error || "Failed to save data.", "Save Failed", "#e40000", "Close", "white", "#ff1616", "#d40000");
    }


  };

  const clearForm = () => {
    setAccountValue(null);
    setDateValue(null);
    setRadioTypeValue('');
    setArApSelected(null);
    setCurrencySelected(null);
    setAmountValue('');
    setBalanceValue('');
    transactionRef.current.value = ''
    tellerRef.current.value = ''
    orgbrRef.current.value = ''
    chqnoRef.current.value = ''
    remarksRef.current.value = ''
  };

  const openDialogWithMessage = (message, title = "Information", titleColor = "black", buttonText = "Close", buttonTextColor = "black", buttonColor = "white", buttonColorh = "white") => {
    setDialogMessage(message);
    setDialogTitle(title);
    setDialogTitleColor(titleColor);
    setDialogButtonText(buttonText);
    setDialogButtonTextColor(buttonTextColor);
    setDialogButtonColor(buttonColor);
    setDialogButtonColorh(buttonColorh);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    // Optional: โฟกัสไปปุ่มเปิด Dialog หรือ element ที่เหมาะสม
    document.getElementById('open-dialog-btn')?.focus();
  };








  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const navigate = useNavigate();

  const handleSubmit2 = async (e) => {
    e.preventDefault();

    try {
      const { email, password, username } = formData;
      const dataToSend = { email, password, username, role: "staff" };
  
      // ส่ง request ไปยัง backend
      const response = await apiClient.post(
        "/auth/register", // เส้นทางที่ backend ของคุณรับการร้องขอ
        dataToSend // ข้อมูลที่ต้องการส่ง
      );
  
      // เก็บ token จาก backend (ถ้ามี)
      if (response.data.token) {
        localStorage.setItem("token", response.data.token);
      }
  
      // แสดงข้อความสำเร็จ
      setMessage("Registration successful! Please log in.");
      setOpenDialog(true);
  
      // นำทางไปหน้า Home
      // navigate("/home");
      setTimeout(() => navigate("/home"), 1000); // รอ 1 วินาทีแล้วนำทาง
    } catch (error) {
      // แสดง error จาก backend
      const errorMessage =
        error.response?.data?.error || "Registration failed. Please try again.";
      setMessage(errorMessage);
      setOpenDialog(true);
    }
  };
  






  return (
    <Container component="main" maxWidth="96%" sx={{marginTop: "10px",border: "0px solid #e0e0e0",boxSizing: "border-box",}}>

      {/* Loading Progress Bar */}
      {loading ? (
        <Box sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          zIndex: 999,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}>
          <LinearProgress variant="determinate" value={progress} sx={{ width: '50%' }} />
        </Box>

        ) : ( 
        
        <Box sx={{ width: '100%',display: "flex",flexDirection: "column", marginLeft:0, marginBottom:0, boxShadow: "none",marginTop: "0px",border: "0px solid #e0e0e0" ,boxSizing: "border-box",
                backgroundColor: "background.paper",
              }}>

          <Box sx={{ borderRadius: 0,boxSizing: "border-box",marginBottom:0, boxShadow: "none",marginTop: "0px",
              textAlign: "center",
              verticalAlign: "middle",
              padding:1,
              backgroundColor: "#f5f5f5",
              fontSize: "calc(14px + 0.5vw)",
              fontWeight: "bold",
              color: "#333",
            }}>
            ข้อมูลสมุดบัญชีธนาคาร - กรอกข้อมูล
          </Box>


          <Box sx={{  marginBottom:"4px", boxShadow: "none",marginTop: "4px",border: "1px solid #e0e0e0" ,boxSizing: "border-box",
              borderRadius: 0,textAlign: "center",verticalAlign: "middle",fontSize: "calc(14px - 0.01vw)",padding:1,
              display: "flex",            // ✅ เพิ่ม
              justifyContent: "center",   // ✅ จัดให้อยู่ตรงกลางแนวนอน
              alignItems: "center",
            }}>

            {files.length > 0 ? (
              <form onSubmit={handleSubmit}>
              <Box sx={{  marginBottom:"4px", boxShadow: "none",marginTop: "4px",border: "0px solid #e0e0e0" ,boxSizing: "border-box",
                        borderRadius: 0, width: 300, textAlign: "left",
                        extAlign: "left",
                        display: "flex",            // ทำให้จัดเรียงเป็นแนวตั้ง
                        flexDirection: "column",    // เรียงเป็นคอลัมน์
                        gap: "15px",                 // ระยะห่างระหว่าง <div> ข้างใน
                        padding: "1px",             // เพิ่ม padding ด้านในกล่องด้วย
                      }}
                >

                <div>
                  <Autocomplete
                    options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => `${option.type} ${option.account}`}
                    value={accountValue}
                    onChange={(event, newValue) => setAccountValue(newValue)}
                    isOptionEqualToValue={(option, value) =>
                      option.account === value.account && option.type === value.type
                    }
                    // sx={{ width: 300 }}
                    renderInput={(params) => <TextField {...params} label="เลือกบัญชีธนาคาร" placeholder="Select Bank Account" style={{ width: 300}} size="small" id="account" required/>}
                    renderGroup={(params) => (
                      <li key={params.key}>
                        <GroupHeader>{params.group}</GroupHeader>
                        <GroupItems>{ params.children}</GroupItems>
                  </li>
                    )}
                  />
                </div>

                {/* <div style={{ position: "relative", display: "inline-block" }} >
                  {accountValue && (
                    <div>
                      เลือกบัญชี: {accountValue.bankname} {accountValue.account} ({accountValue.type})
                    </div>
                  )}
                </div> */}

                <div>
                    <DatePicker value={dateValue} onChange={handleDateChange}
                    />
                    {/* <p>ค่าที่เลือก: {dateValue ? dateValue.format('YYYY-MM-DD HH:mm')  : 'ยังไม่เลือก'}</p>                     */}
                      
                </div>

                <div>
                  <FormControl>
                    <FormLabel component="legend">เลือกประเภทรายการ*</FormLabel>
                    <RadioGroup
                      row
                      // aria-labelledby="radio-buttons-label"
                      id="radioType"
                      name="radioType"
                      value={radioTypeValue}
                      onChange={handleRadioChange}
                    >
                      <FormControlLabel value="deposit" control={<Radio />} label="ฝาก (Deposit)" />
                      <FormControlLabel value="withdrawal" control={<Radio />} label="ถอน (Withdrawal)" />
                    </RadioGroup>
                  </FormControl>

                </div>

                {/* <div style={{ position: "relative", display: "inline-block" }} >
                    <p>ค่าที่เลือก: {radioTypeValue ? radioTypeValue  : 'ยังไม่เลือก'}</p>                                          
                </div> */}

                {radioTypeValue && (
                  <>
                  <div>
                    <Autocomplete
                      options={arapValue}
                      getOptionLabel={(option) => `${option.name} (${option.id})`}
                      value={arapSelected}
                      onChange={(event, newValue) => setArApSelected(newValue)}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      renderInput={(params) => 
                      <TextField {...params} label={`เลือกบัญชี${labelText || ''}`} placeholder={`Select ${placeholderText || ''}`} style={{ width: 300}} size="small" id="masteraccount"/>}
                      // sx={{ marginTop: 2, width: 300 }}
                    />
                  </div>

                  <div>
                    <Autocomplete
                      options={currencyValue}
                      getOptionLabel={(option) => `${option.name}`}
                      value={currencySelected}
                      onChange={(event, newValue) => setCurrencySelected(newValue)}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      renderInput={(params) => 
                      <TextField {...params} label={`เลือกสกุลเงิน${''}`} placeholder={`Select Currency${''}`} style={{ width: 150}} size="small" id="mastercurrency" required/>}
                      // sx={{ marginTop: 2, width: 300 }}
                    />
                  </div>

                  <div>
                    <TextField
                      id="amount"
                      name="amount"
                      label={`จำนวนเงิน${labelAmount || ''}`}
                      placeholder={`${placeholderAmount || ''}`}
                      autoComplete="off"
                      variant="outlined"
                      size="small"
                      required
                      style={{ width: 250 }}
                      value={amountValue}
                      onChange={(e) => {
                        const value = e.target.value;
                        const regex = /^\d*\.?\d{0,2}$/;
                        if (value === "" || regex.test(value)) {
                          setAmountValue(value);
                        }
                      }}
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      inputProps={{
                        inputMode: "decimal",
                        pattern: "[0-9.]*"
                      }}
                    />
                  </div>

                  <div>
                    <TextField
                      id="balance"
                      name="balance"
                      label="ยอดคงเหลือ"
                      placeholder="Balance"
                      autoComplete="off"
                      variant="outlined"
                      size="small"
                      style={{ width: 250 }}
                      value={balanceValue}
                      onChange={(e) => {
                        const value = e.target.value;
                        const regex = /^-?\d*(\.\d{0,2})?$/; // รองรับเลขติดลบและทศนิยม 2 ตำแหน่ง
                        if (value === "" || regex.test(value)) {
                          setBalanceValue(value);
                        }
                      }}
                      onKeyDown={(e) => {
                        if (["e", "E", "+"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      inputProps={{
                        inputMode: "decimal",
                        pattern: "-?\\d*(\\.\\d{0,2})?"
                      }}
                    />
                  </div>

                  <div>
                    <TextField
                      id="transaction"
                      name="transaction"
                      label="รายการ/คำย่อ"
                      placeholder="Transaction"
                      autoComplete="off"
                      variant="outlined"
                      style={{ width: 300 }}
                      size="small"
                      inputRef={transactionRef}
                    />
                  </div>

                  <div>
                    <TextField
                      id="teller"
                      name="teller"
                      label="รหัสรายการ/ผ่านทาง"
                      placeholder="Teller/Via"
                      autoComplete="off"
                      variant="outlined"
                      style={{ width: 300 }}
                      size="small"
                      inputRef={tellerRef}
                    />
                  </div>

                  <div>
                    <TextField
                      id="orgbr"
                      name="orgbr"
                      label="สาขา"
                      placeholder="Org BR"
                      autoComplete="off"
                      variant="outlined"
                      style={{ width: 300 }}
                      size="small"
                      inputRef={orgbrRef}
                    />
                  </div>

                  <div>
                    <TextField
                      id="chqno"
                      name="chqno"
                      label="เลขที่เช็ค"
                      placeholder="Chq.No."
                      autoComplete="off"
                      variant="outlined"
                      style={{ width: 300 }}
                      size="small"
                      inputRef={chqnoRef}
                    />
                  </div>

                  <div>
                    <TextField
                      id="remarks"
                      name="remarks"
                      label="หมายเหตุ"
                      placeholder="Remarks"
                      autoComplete="off"
                      variant="outlined"
                      style={{ width: 300 }}
                      multiline={true}
                      rows={3} 
                      inputRef={remarksRef}
                    />

                  </div>

                  <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                      type="submit"
                      fullWidth={false}
                      variant="contained"
                      // color="primary"
                      sx={{
                      padding: "8px 15px",
                      backgroundColor: "#0061d4",
                      color: "white",
                      border: "none",
                      fontSize: "calc(8px + 0.6vw)",
                      cursor: "pointer",
                      marginRight: "10px",
                      boxShadow: "none", // เอาเงาออกให้เหมือนปุ่มปกติ
                      '&:hover': {
                        backgroundColor: "#004eaa", // สี hover ที่เข้ากัน
                        boxShadow: "none",
                      },
                    }}
                    >
                     บันทึกข้อมูล
                  </Button>
                  </div>

                  </>
                )}

                
                

              </Box>

              </form>

            ) : (
                "ไม่พบข้อมูลบัญชีธนาคาร (Bank Accounts Master) กรุณาตรวจสอบอีกครั้ง"
            )}

          </Box>


        </Box>

        
    
      )}


 

      <Dialog open={openDialog} onClose={handleCloseDialog} sx={{maxWidth: "auto",  width: "auto", margin: "auto",overflow: "visible", }}>
          <DialogTitle sx={{color: dialogTitleColor,fontSize: "1.3rem",fontWeight: "400",textAlign: "left",padding: "5px",minHeight: "30px",whiteSpace: "pre-wrap",paddingRight: "40px", }}>
          {dialogTitle} 
          </DialogTitle>
          <IconButton sx={{position: "absolute",right: "5px",top: "3px",borderRadius: "8px", }} onClick={handleCloseDialog}> 
              <CloseIcon /> 
          </IconButton>
          <DialogContent sx={{ fontSize: "1rem",maxHeight: "100%", overflowY: "auto", paddingBottom: "0",whiteSpace: "pre-wrap",wordBreak: "break-word",textAlign: "center", }}>
          {dialogMessage}
          </DialogContent>
          <DialogActions sx={{display: "flex", justifyContent: "center", alignItems: "center",marginTop: "20px",}}>
          <Button variant="contained" sx={{ backgroundColor: dialogButtonColor, color: dialogButtonTextColor, "&:hover": { backgroundColor: dialogButtonColorh } }} onClick={handleCloseDialog} autoFocus>
              {dialogButtonText}
          </Button>
          </DialogActions>
      </Dialog>

    </Container>
  );
};

export default FillBankStatement;
